<template class="full-height">
  <div class="coupon-app-container" style="position: relative; height: 100%; padding: 15px">
    <UploadList />
  </div>
</template>

<script>
import UploadList from '@/views/ita/agency/outSideContract/uploadList.vue'
export default {
  name: 'CommonForms',
  components: {
    UploadList,
  },
  data() {
    return {}
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
